import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-宠播社区",
  "use": "icon-宠播社区-usage",
  "viewBox": "0 0 160 160",
  "content": "<symbol viewBox=\"0 0 160 160\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-宠播社区\">\n<path d=\"M69.6 80C69.6 89.9652 62.1836 97.4 53.8 97.4C45.4164 97.4 38 89.9652 38 80C38 70.0348 45.4164 62.6 53.8 62.6C62.1836 62.6 69.6 70.0348 69.6 80Z\" stroke-width=\"10\" />\n<path d=\"M122.4 80C122.4 89.9652 114.984 97.4 106.6 97.4C98.2164 97.4 90.8 89.9652 90.8 80C90.8 70.0348 98.2164 62.6 106.6 62.6C114.984 62.6 122.4 70.0348 122.4 80Z\" stroke-width=\"10\" />\n<path d=\"M146.2 147L38.8001 147C24.993 147 13.8001 135.807 13.8001 122L13.8001 38C13.8001 24.1929 24.993 13 38.8001 13L121.2 13C135.007 13 146.2 24.1929 146.2 38L146.2 147Z\" stroke-width=\"10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/宠播社区.svg
// module id = QjtE
// module chunks = 26